var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initParallax = /* @__PURE__ */ __name(($el) => {
  const calculateParallax = /* @__PURE__ */ __name((progress, breakpoints) => {
    const points = breakpoints.split(",").map((pair) => {
      const [p, v] = pair.trim().split(":").map(Number);
      return { progress: p, value: v };
    }).sort((a, b) => a.progress - b.progress);
    let start = points[0], end = points[points.length - 1];
    for (let i = 0; i < points.length - 1; i++) {
      if (progress >= points[i].progress && progress <= points[i + 1].progress) {
        start = points[i];
        end = points[i + 1];
        break;
      }
    }
    const range = end.progress - start.progress;
    const factor = range === 0 ? 0 : (progress - start.progress) / range;
    const interpolated = start.value + (end.value - start.value) * factor;
    return interpolated;
  }, "calculateParallax");
  const section = $el.closest(".shopify-section");
  if (section.hasAttribute("x-init") || !section) {
    return { calculateParallax };
  }
  section.setAttribute("x-data", "{ scrollProgress: 0 }");
  section.setAttribute(
    "x-init",
    "$watch('$data.scrollTop', () => { const rect = $el.getBoundingClientRect();scrollProgress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);scrollProgress = Math.min(Math.max(scrollProgress, 0), 1); })"
  );
  return { calculateParallax };
}, "initParallax");
window._sections["initParallax"] = initParallax;
